<script setup>
import { mapErrors } from '@/utilities';
import { useForm } from '@inertiajs/vue3';

import { inject, ref } from 'vue';

// Components
import AddressForm from '@/Components/Address/AddInForm.vue';
import Button from '@/Components/Button/Button.vue';
import FormSingleSettingBar from '@/Components/Form/FormSingleSettingBar.vue';
import Form from '@/Components/Location/Form.vue';
// Icons
import saveIcon from '@i/save-white.svg';
import DeleteLocationForm from './DeleteLocationForm.vue';

const route = inject('route');
const props = defineProps({
    location: Object,
    claOptions: Object,
});

const form = useForm({
    cost_center: '',
    ...props.location,
    ...props.location.address,
});

const sendForm = () => {
    form.put(route('location.locations.update', { location: props.location.id }), {
        preserveState: true,
        preserveScroll: true,
        onError: (errors) => (form.errors = mapErrors(errors)),
    });
};

const showDeleteLocationForm = ref(false);
const openDeleteLocationForm = () => {
    showDeleteLocationForm.value = true;
};
</script>

<template>
    <FormSingleSettingBar :title="$t('Contact Details')">
        <FormKit type="form" id="location-update-form" @submit="sendForm" :actions="false">
            <div class="grid gap-x-8 md:grid-cols-2">
                <Form :form="form" :claOptions="claOptions" />
            </div>

            <FormSingleSettingBar
                v-if="location.can_be_deleted"
                :title="$t('Delete {model}', { model: $t('location') })"
            >
                <div class="grid gap-5">
                    <p>
                        {{
                            $t('If you created this {model} by mistake, it can be removed.', { model: $t('location') })
                        }}
                    </p>
                    <Button
                        type="button"
                        danger
                        admin
                        @click="openDeleteLocationForm()"
                        :text="$t('Delete {model}', { model: $t('location') })"
                    />
                </div>
            </FormSingleSettingBar>
            <FormSingleSettingBar :title="$t('Address')">
                <AddressForm :parentForm="form" />
            </FormSingleSettingBar>
            <div class="flex items-center justify-end w-full">
                <div class="">
                    <Button
                        type="button"
                        :processing="form.processing"
                        :recentlySuccessful="form.recentlySuccessful"
                        :text="$t('Save')"
                        :icon="saveIcon"
                        @click="sendForm"
                    />
                </div>
            </div>
        </FormKit>
    </FormSingleSettingBar>

    <DeleteLocationForm v-model:showing="showDeleteLocationForm" :location="location" />
</template>
